import { render, staticRenderFns } from "./WorkerDashboard.vue?vue&type=template&id=0711cfd3&scoped=true&"
import script from "./WorkerDashboard.vue?vue&type=script&lang=js&"
export * from "./WorkerDashboard.vue?vue&type=script&lang=js&"
import style0 from "./WorkerDashboard.vue?vue&type=style&index=0&id=0711cfd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0711cfd3",
  null
  
)

export default component.exports